export const ERROR_CODE_TO_MESSAGE = {
    NOT_UNIQUE_FILTER : 'This name already exists.'
};
export const DEFAULT_ERROR_MESSAGE = 'Unknown error!';

export const NO_CUSTOM_XML_PART_FOUND_MESSAGE = 'No custom XML parts found!';

export const INVALID_DOC_STATUS_ERROR_MESSAGE = 'Invalid document status!';
